import { css } from '@emotion/react';
import { baseStyles as baseStyles$1 } from './Input.js';
var element = 'button';
var selectors = ['button.input', 'a.input'];
var defaultProps = {
  role: 'button'
};
var baseStyles = /*#__PURE__*/css(baseStyles$1, ";display:flex;gap:var(--spacing-l2);align-items:center;justify-content:space-between;cursor:pointer;&>*:not(svg){flex:1;text-align:left;}&[data-pseudo='hover'],&:hover{background:var(--surface-hover);}&[data-pseudo='active'],&:active{background:var(--surface-active);}" + (process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;"));
export { baseStyles, defaultProps, element, selectors };
